import { makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles<Theme, {}>(
  _ => ({
    labelContainer: {
      display: "flex",
      alignItems: "center",
      fontWeight: 600,
      gap: "4px"
    }
  }),
  { name: "CouponTaggingCard" }
);
